module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.showModalFotos) ? _c('transition', {
    attrs: {
      "id": "fotos",
      "name": "fotos"
    }
  }, [_c('div', {
    staticClass: "modal-cus-mask"
  }, [_c('div', {
    staticClass: "modal-cus-wrapper"
  }, [_c('div', {
    staticClass: "modal-cus-container"
  }, [_c('div', {
    staticClass: "modal-cus-header"
  }, [_vm._t("header", function() {
    return [_c('div', {
      staticClass: "title-boreder"
    }, [_c('div', {
      staticClass: "box-title box-title-sub"
    }, [_c('img', {
      staticStyle: {
        "padding-bottom": "6px",
        "padding-right": "8px"
      },
      attrs: {
        "src": "/static/img/svg/photo.svg"
      }
    }), _vm._v(" "), _c('span', [_vm._v("ver fotos")])]), _vm._v(" "), _c('button', {
      staticClass: "close",
      staticStyle: {
        "padding": "5px",
        "position": "relative !important",
        "top": "-35px !important"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.showModalFotos = false
        }
      }
    }, [_c('span', {
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-cus-body"
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "slideshow-container-ora"
    }, _vm._l((_vm.fotos), function(foto, fotosIndex) {
      return _c('div', {
        key: fotosIndex,
        staticClass: "slides-ora fade-ora"
      }, [_c('button', {
        staticClass: "close",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.download(foto)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-download",
        attrs: {
          "aria-hidden": "true"
        }
      })]), _vm._v(" "), _c('inner-image-zoom', {
        attrs: {
          "src": foto,
          "zoomSrc": foto
        }
      })], 1)
    }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, _vm._l((_vm.fotos), function(foto, fotosIndex) {
      return _c('span', {
        key: fotosIndex,
        staticClass: "dot-ora",
        on: {
          "click": function($event) {
            return _vm.currentSlide(fotosIndex + 1)
          }
        }
      })
    }), 0)]
  })], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.showModalCopiar) ? _c('transition', {
    attrs: {
      "id": "copiar",
      "name": "copiar"
    }
  }, [_c('div', {
    staticClass: "modal-cus-mask"
  }, [_c('div', {
    staticClass: "modal-cus-wrapper"
  }, [_c('div', {
    staticClass: "modal-cus-container",
    staticStyle: {
      "width": "450px"
    }
  }, [_c('div', {
    staticClass: "modal-cus-header"
  }, [_vm._t("header", function() {
    return [_c('div', {
      staticClass: "title-boreder"
    }, [_c('div', {
      staticClass: "box-title box-title-sub"
    }, [_c('span', [_vm._v("Enviar Vínculo")])]), _vm._v(" "), _c('button', {
      staticClass: "close",
      staticStyle: {
        "padding": "5px",
        "position": "relative !important",
        "top": "-35px !important"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.showModalCopiar = false
        }
      }
    }, [_c('span', {
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-cus-body",
    staticStyle: {
      "margin": "10px"
    }
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-1 col-xs-2",
      staticStyle: {
        "font-size": "24px",
        "padding-top": "15px",
        "color": "#3D77FF"
      }
    }, [_c('i', {
      ref: "atrack",
      staticClass: "fa fa-link a-icon",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-8 col-md-8 col-xs-10 text-left"
    }, [_vm._v("\n                        Comparte el seguimiento de tu pedido, pídele a la otra persona que ingrese tu nombre para ver el tracking\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-3 col-md-3 col-xs-12 text-center"
    }, [_c('button', {
      staticClass: "btn btn-ora-blue",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.copy()
        }
      }
    }, [_vm._v("\n                          Copiar\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "div-copy",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": "divCopy"
      }
    }, [_vm._v("Copiado")])])])])])]
  })], 2)])])])]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "modal-ora",
    attrs: {
      "id": "detail",
      "name": "detail"
    }
  }, [_c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('div', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "6px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/svg/list.svg"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Detalle de Pedido")])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('detail')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "filterContainer"
  }, [(!_vm.mobile) ? _c('vuetable', {
    key: _vm.tableKey,
    ref: "vuetable",
    attrs: {
      "id": "resultTable",
      "api-mode": false,
      "fields": _vm.tableFields,
      "css": _vm.tableCSS.table,
      "noDataTemplate": "No se encontraron resultados",
      "data": _vm.tableData
    },
    scopedSlots: _vm._u([{
      key: "itemPos",
      fn: function(props) {
        return [_c('div', {
          staticClass: "text-right"
        }, [_vm._v("\n              " + _vm._s(props.rowData.itemPos) + "\n            ")])]
      }
    }, {
      key: "lpn",
      fn: function(props) {
        return [_c('div', [_c('span', [_vm._v(_vm._s(props.rowData.lpn))])])]
      }
    }, {
      key: "itemCode",
      fn: function(props) {
        return [_c('div', [_vm._v("\n              " + _vm._s(props.rowData.itemCode) + "\n            ")])]
      }
    }, {
      key: "itemDescription",
      fn: function(props) {
        return [_c('div', [_vm._v("\n              " + _vm._s(props.rowData.itemDescription) + "\n            ")])]
      }
    }, {
      key: "quantityOrder",
      fn: function(props) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_vm._v("\n              " + _vm._s(props.rowData.quantityOrder) + "\n            ")])]
      }
    }, {
      key: "quantitySent",
      fn: function(props) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_vm._v("\n              " + _vm._s(props.rowData.quantitySent) + "\n            ")])]
      }
    }, {
      key: "quantityDelivered",
      fn: function(props) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_vm._v("\n              " + _vm._s(props.rowData.quantityDelivered) + "\n            ")])]
      }
    }, {
      key: "quantityRejected",
      fn: function(props) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_vm._v("\n              " + _vm._s(props.rowData.quantityRejected) + "\n            ")])]
      }
    }], null, false, 2414204964)
  }) : _c('div', {
    staticClass: "col-12"
  }, _vm._l((this.tableData.data), function(detail, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('span', {
      staticClass: "data-field"
    }, [_vm._v("Nro")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6",
      style: ({
        background: index % 2 === 0 ? 'white' : '#FAFBFF'
      })
    }, [_c('span', {
      staticClass: "data-title"
    }, [_vm._v(_vm._s(detail.itemPos))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('span', {
      staticClass: "data-field"
    }, [_vm._v("LPN / Precintos")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6",
      style: ({
        background: index % 2 === 0 ? 'white' : '#FAFBFF'
      })
    }, [_c('span', {
      staticClass: "data-title"
    }, [_vm._v(_vm._s(detail.lpn))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('span', {
      staticClass: "data-field"
    }, [_vm._v("Código SKU")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6",
      style: ({
        background: index % 2 === 0 ? 'white' : '#FAFBFF'
      })
    }, [_c('span', {
      staticClass: "data-title"
    }, [_vm._v(_vm._s(detail.itemCode))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('span', {
      staticClass: "data-field"
    }, [_vm._v("Descripción SKU")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6",
      style: ({
        background: index % 2 === 0 ? 'white' : '#FAFBFF'
      })
    }, [_c('span', {
      staticClass: "data-title"
    }, [_vm._v(_vm._s(detail.itemDescription))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('span', {
      staticClass: "data-field"
    }, [_vm._v("Cant. Pedido")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6",
      style: ({
        background: index % 2 === 0 ? 'white' : '#FAFBFF'
      })
    }, [_c('span', {
      staticClass: "data-title"
    }, [_vm._v(_vm._s(detail.quantityOrder))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('span', {
      staticClass: "data-field"
    }, [_vm._v("Cant. Despachada")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6",
      style: ({
        background: index % 2 === 0 ? 'white' : '#FAFBFF'
      })
    }, [_c('span', {
      staticClass: "data-title"
    }, [_vm._v(_vm._s(detail.quantitySent))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('span', {
      staticClass: "data-field"
    }, [_vm._v("Cant. Entregada")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6",
      style: ({
        background: index % 2 === 0 ? 'white' : '#FAFBFF'
      })
    }, [_c('span', {
      staticClass: "data-title"
    }, [_vm._v(_vm._s(detail.quantityDelivered))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('span', {
      staticClass: "data-field"
    }, [_vm._v("Cant. Rechazada")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6",
      style: ({
        background: index % 2 === 0 ? 'white' : '#FAFBFF'
      })
    }, [_c('span', {
      staticClass: "data-title"
    }, [_vm._v(_vm._s(detail.quantityRejected))])])]), _vm._v(" "), _c('br')])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    class: _vm.isOrder ? 'container-order' : 'container-tra'
  }, [_c('div', {
    class: _vm.isOrder ? 'nav-tra-order' : 'nav-tra'
  }, [(_vm.existe && _vm.order.accountLogo != null && _vm.isOrder) ? _c('img', {
    staticClass: "ico-account",
    attrs: {
      "src": ("data:image/png;base64," + (_vm.order.accountLogo))
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isOrder) ? _c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": "/static/img/logo-tra.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.existe && _vm.order.accountLogo != null && !_vm.isOrder) ? _c('img', {
    staticStyle: {
      "height": "35px"
    },
    attrs: {
      "src": ("data:image/png;base64," + (_vm.order.accountLogo))
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.existe == 1) ? _c('div', {
    staticClass: "col"
  }, [(_vm.order.realTimeFlag == 1) ? _c('div', {
    staticClass: "row row-button"
  }, [_c('span', {
    staticClass: "ub-actual",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.getPoint()
      }
    }
  }, [_c('img', {
    staticClass: "ub-icon",
    attrs: {
      "src": "/static/img/svg/pointer.svg"
    }
  }), _vm._v(" "), (!_vm.mobile) ? _c('span', [_vm._v("Ver ubicación actual")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isPoint) ? _c('l-map', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "zoom": _vm.zoom,
      "center": _vm.center
    }
  }, [_c('l-tile-layer', {
    attrs: {
      "url": "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    }
  }), _vm._v(" "), _c('l-marker', {
    attrs: {
      "lat-lng": _vm.center
    }
  }, [_c('l-icon', {
    attrs: {
      "icon-url": _vm.iconGP,
      "icon-size": [_vm.iconHE, _vm.iconWI],
      "icon-anchor": [_vm.iconHE, _vm.iconWI]
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isPoint && !_vm.isOrder) ? _c('div', {
    staticStyle: {
      "height": "70px"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.mobile) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-10"
  }, [_c('div', {
    class: _vm.isPoint ? 'box-tra' : 'box-tra-sm'
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row div-ora-flex"
  }, [_c('div', {
    staticClass: "col-md-6 img-back"
  }, [(_vm.showBack) ? _c('img', {
    staticStyle: {
      "cursor": "pointer",
      "padding-right": "5px"
    },
    attrs: {
      "src": "/static/img/svg/arrow-left.svg"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('hiddenTrack', false)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "label-bold-tra"
  }, [_vm._v("N° Pedido : " + _vm._s(_vm.order.customerOrderNumber == null ? _vm.order.orderNumber : _vm.order.customerOrderNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [(_vm.isOrder) ? _c('button', {
    staticClass: "btn btn-ora-blue",
    on: {
      "click": function($event) {
        return _vm.showDetail()
      }
    }
  }, [_vm._v("Ver Detalle")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-tra"
  }, [_c('div', {
    staticClass: "card-header-tra"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "status",
    style: ({
      background: _vm.order.configuration.minTextFundColor == '' ? 'black' : _vm.order.configuration.minTextFundColor,
      color: _vm.order.configuration.minTextColor == '' ? 'white' : _vm.order.configuration.minTextColor
    })
  }, [_vm._v(_vm._s(_vm._f("firstLetter")(_vm.order.statusDescription)))])])]), _vm._v(" "), _c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "outer"
  }, _vm._l((_vm.eventList), function(event, index) {
    return _c('div', {
      key: index,
      staticClass: "card-tl"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "card-lt-title"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")((event.reason == '' ? event.event : event.reason))))]), (event.existImage) ? _c('a', {
      staticClass: "arrow-tra",
      attrs: {
        "data-toggle": "collapse",
        "href": ("#col" + index)
      }
    }, [_c('i', {
      staticClass: "fa fa-chevron-down",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "p-tra"
    }, [_vm._v("\n                                      " + _vm._s(_vm._f("formatDate")(event.eventDate, "LLL")) + "\n                                      "), _c('br'), _vm._v(" "), (event.location != '' && event.location.trim() != '-') ? _c('span', [_vm._v(_vm._s(_vm._f("firstLetter")(event.location)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "panel-collapse collapse",
      staticStyle: {
        "padding-bottom": "10px"
      },
      attrs: {
        "id": ("col" + index)
      }
    }, [(event.imageUrl1 != '') ? _c('img', {
      staticClass: "img-event",
      attrs: {
        "src": ("" + (event.imageUrl1))
      },
      on: {
        "click": function($event) {
          return _vm.modalFotos(event, 0)
        }
      }
    }) : _vm._e(), _vm._v(" "), (event.imageUrl2 != '') ? _c('img', {
      staticClass: "img-event",
      attrs: {
        "src": ("" + (event.imageUrl2))
      },
      on: {
        "click": function($event) {
          return _vm.modalFotos(event, 1)
        }
      }
    }) : _vm._e(), _vm._v(" "), (event.imageUrl3 != '') ? _c('img', {
      staticClass: "img-event",
      attrs: {
        "src": ("" + (event.imageUrl3))
      },
      on: {
        "click": function($event) {
          return _vm.modalFotos(event, 2)
        }
      }
    }) : _vm._e()])])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-6"
  }, [(!_vm.mobile) ? _c('div', {
    staticClass: "row"
  }, [(!_vm.isOrder) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "msg-tra",
    style: ({
      background: _vm.order.configuration.fundColor
    })
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', [_c('div', {
    staticClass: "msg-icono",
    style: ({
      background: _vm.order.configuration.iconFundColor
    })
  }, [_c('img', {
    staticClass: "msg-img",
    attrs: {
      "src": ("data:image/png;base64," + (_vm.order.configuration.icon))
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "msg-title",
    style: ({
      color: _vm.order.configuration.higherTextColor
    })
  }, [_vm._v("Hola, " + _vm._s(_vm._f("firstLetter")(_vm.order.customerName)))]), _vm._v(" "), _c('p', {
    staticClass: "msg-p",
    style: ({
      color: _vm.order.configuration.lowerTextColor
    })
  }, [_vm._v("Tu pedido tiene un estado de " + _vm._s(_vm._f("minus")(_vm.order.statusDescription)))])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-tra"
  }, [_c('div', {
    staticClass: "card-header-tra"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('span', [_c('a', {
    staticClass: "a-tra",
    attrs: {
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function($event) {
        _vm.showModalCopiar = true
      }
    }
  }, [_c('i', {
    ref: "atrack",
    staticClass: "fa fa-link a-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Compartir Pedido")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body-tra"
  }, [_c('div', {
    staticClass: "row data-space"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('span', {
    staticClass: "data-field"
  }, [_vm._v(_vm._s(this.order.tracking))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('span', {
    staticClass: "data-field"
  }, [_vm._v(_vm._s(_vm.order.customerOrderNumber == null ? _vm.order.orderNumber : _vm.order.customerOrderNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "row data-space"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('label', {
    staticClass: "data-field",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm._v(_vm._s(_vm._f("firstLetter")(this.order.customerName)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('span', {
    staticClass: "data-field"
  }, [_vm._v(_vm._s(_vm.order.destinyContactPhone))])])]), _vm._v(" "), _c('div', {
    staticClass: "row data-space"
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('label', {
    staticClass: "data-field",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm._v(_vm._s(_vm._f("firstLetter")(this.order.sourceAddress)) + " "), _c('br'), _vm._v(_vm._s(_vm._f("firstLetter")(this.order.sourceNameUbigeo)) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('label', {
    staticClass: "data-field",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm._v(_vm._s(_vm._f("firstLetter")(_vm.order.destinyAddress)) + " "), _c('br'), _vm._v(" " + _vm._s(_vm._f("firstLetter")(this.order.destinyNameUbigeo)))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "help-tra"
  }, [_c('div', {
    staticClass: "row help-container"
  }, [_vm._m(8), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "help-title"
  }, [_vm._v(_vm._s(_vm.order.helpQuestion.trim() === '' ? '¿Necesitas ayuda con tu pedido?' : _vm.order.helpQuestion.trim()))]), _vm._v(" "), (_vm.order.contactType == 'TELF') ? _c('a', {
    staticClass: "help-p",
    attrs: {
      "href": ("tel:" + (_vm.order.contactValue))
    }
  }, [_vm._v("Contáctate con nosotros")]) : (_vm.order.contactType == 'MAIL') ? _c('a', {
    staticClass: "help-p",
    attrs: {
      "href": ("mailto:" + (_vm.order.contactValue))
    }
  }, [_vm._v("Contáctate con nosotros")]) : _c('a', {
    staticClass: "help-p",
    attrs: {
      "href": ("" + (_vm.order.contactValue)),
      "target": "_blank"
    }
  }, [_vm._v("Contáctate con nosotros")])])])])])])])])])])]), _vm._v(" "), (!_vm.mobile) ? _c('div', {
    staticClass: "col-xs-1"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mobile) ? _c('div', {
    staticClass: "row"
  }, [(!_vm.isOrder) ? _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('div', {
    class: _vm.order.statusDescription.length > 10 ? (_vm.isPoint ? 'msg-tra-high' : 'msg-tra-high-vacio') : (_vm.isPoint ? 'msg-tra' : 'msg-tra-vacio'),
    style: ({
      background: _vm.order.configuration.fundColor
    })
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 col-md-3",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('div', {
    staticClass: "msg-icono",
    style: ({
      color: _vm.order.configuration.iconFundColor
    })
  }, [_c('img', {
    staticClass: "msg-img",
    attrs: {
      "src": ("data:image/png;base64," + (_vm.order.configuration.icon))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 col-md-9",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    }
  }, [_c('div', {
    staticClass: "msg-title",
    style: ({
      color: _vm.order.configuration.higherTextColor
    })
  }, [_vm._v("Hola, " + _vm._s(_vm._f("firstLetter")(_vm.order.customerName)))]), _vm._v(" "), _c('p', {
    staticClass: "msg-p",
    style: ({
      color: _vm.order.configuration.lowerTextColor
    })
  }, [_vm._v("Tu pedido tiene un estado de " + _vm._s(_vm._f("minus")(_vm.order.statusDescription)))])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mobile) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('div', {
    class: _vm.isPoint ? 'box-tra' : 'box-tra-sm'
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 img-back"
  }, [(_vm.showBack) ? _c('img', {
    staticStyle: {
      "padding-right": "5px"
    },
    attrs: {
      "src": "/static/img/svg/arrow-left.svg"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('hiddenTrack', false)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "label-bold-tra"
  }, [_vm._v("N° Pedido : " + _vm._s(_vm.order.customerOrderNumber == null ? _vm.order.orderNumber : _vm.order.customerOrderNumber))])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    staticClass: "a-tab",
    class: {
      active: _vm.isActive('track')
    },
    attrs: {
      "role": "tab",
      "data-toggle": "tab",
      "href": "#track",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setActive('track')
      }
    }
  }, [_vm._v("Tracking")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "a-tab",
    class: {
      active: _vm.isActive('info')
    },
    attrs: {
      "role": "tab",
      "data-toggle": "tab",
      "href": "#info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setActive('info')
      }
    }
  }, [_vm._v("Información del Pedido")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "tabTrack"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    class: {
      'active': _vm.isActive('track')
    },
    attrs: {
      "id": "track"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    }
  }, [_c('div', {
    staticClass: "nav-tra"
  }, [_vm._m(9), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "status",
    style: ({
      background: _vm.order.configuration.minTextFundColor == '' ? 'black' : _vm.order.configuration.minTextFundColor,
      color: _vm.order.configuration.minTextColor == '' ? 'white' : _vm.order.configuration.minTextColor
    })
  }, [_vm._v(_vm._s(_vm._f("firstLetter")(_vm.order.statusDescription)))])])]), _vm._v(" "), _c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "outer"
  }, _vm._l((_vm.eventList), function(event, index) {
    return _c('div', {
      key: index,
      staticClass: "card-tl"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "card-lt-title"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")((event.reason == '' ? event.event : event.reason))))]), (event.existImage) ? _c('a', {
      staticClass: "arrow-tra",
      attrs: {
        "data-toggle": "collapse",
        "href": ("#col" + index)
      }
    }, [_c('i', {
      staticClass: "fa fa-chevron-down",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "p-tra"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(event.eventDate, "LLL")) + "\n                                            "), _c('br'), _vm._v(" "), (event.location != '' && event.location.trim() != '-') ? _c('span', [_vm._v(_vm._s(_vm._f("firstLetter")(event.location)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "panel-collapse collapse",
      staticStyle: {
        "padding-bottom": "10px"
      },
      attrs: {
        "id": ("col" + index)
      }
    }, [(event.imageUrl1 != '') ? _c('img', {
      staticClass: "img-event",
      attrs: {
        "src": ("" + (event.imageUrl1))
      },
      on: {
        "click": function($event) {
          return _vm.modalFotos(event, 0)
        }
      }
    }) : _vm._e(), _vm._v(" "), (event.imageUrl2 != '') ? _c('img', {
      staticClass: "img-event",
      attrs: {
        "src": ("" + (event.imageUrl2))
      },
      on: {
        "click": function($event) {
          return _vm.modalFotos(event, 1)
        }
      }
    }) : _vm._e(), _vm._v(" "), (event.imageUrl3 != '') ? _c('img', {
      staticClass: "img-event",
      attrs: {
        "src": ("" + (event.imageUrl3))
      },
      on: {
        "click": function($event) {
          return _vm.modalFotos(event, 2)
        }
      }
    }) : _vm._e()])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "help-tra"
  }, [_c('div', {
    staticClass: "row help-container"
  }, [_vm._m(10), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "help-title"
  }, [_vm._v(_vm._s(_vm.order.helpQuestion.trim() === '' ? '¿Necesitas ayuda con tu pedido?' : _vm.order.helpQuestion.trim()))]), _vm._v(" "), (_vm.order.contactType == 'TELF') ? _c('a', {
    staticClass: "help-p",
    attrs: {
      "href": ("tel:" + (_vm.order.contactValue))
    }
  }, [_vm._v("Contáctate con nosotros")]) : (_vm.order.contactType == 'MAIL') ? _c('a', {
    staticClass: "help-p",
    attrs: {
      "href": ("mailto:" + (_vm.order.contactValue))
    }
  }, [_vm._v("Contáctate con nosotros")]) : _c('a', {
    staticClass: "help-p",
    attrs: {
      "href": ("" + (_vm.order.contactValue)),
      "target": "_blank"
    }
  }, [_vm._v("Contáctate con nosotros")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    class: {
      'active': _vm.isActive('info')
    },
    attrs: {
      "id": "info"
    }
  }, [(_vm.isOrder) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-ora-blue",
    staticStyle: {
      "margin": "15px 0px"
    },
    on: {
      "click": function($event) {
        return _vm.showDetail()
      }
    }
  }, [_vm._v("Ver Detalle")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    }
  }, [_c('div', {
    staticClass: "row data-space"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-md-6 col-lg-6 data-mob text-right"
  }, [_c('span', {
    staticClass: "data-field"
  }, [_vm._v(_vm._s(this.order.tracking))])])]), _vm._v(" "), _c('div', {
    staticClass: "row data-space"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-md-6 col-lg-6 data-mob text-right"
  }, [_c('span', {
    staticClass: "data-field"
  }, [_vm._v(_vm._s(_vm.order.customerOrderNumber == null ? _vm.order.orderNumber : _vm.order.customerOrderNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "row data-space"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-md-8 col-lg-8 data-mob text-right"
  }, [_c('span', {
    staticClass: "data-field"
  }, [_vm._v(_vm._s(_vm._f("firstLetter")(this.order.customerName)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row data-space"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-md-6 col-lg-6 data-mob text-right"
  }, [_c('span', {
    staticClass: "data-field"
  }, [_vm._v(_vm._s(_vm.order.destinyContactPhone))])])]), _vm._v(" "), _c('div', {
    staticClass: "row data-space-border"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-md-6 col-lg-6 data-mob text-right"
  }, [_c('span', {
    staticClass: "data-field"
  }, [_vm._v(_vm._s(_vm._f("firstLetter")(this.order.sourceAddress)) + " "), _c('br'), _vm._v(" " + _vm._s(_vm._f("firstLetter")(this.order.sourceNameUbigeo)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row data-space-border",
    staticStyle: {
      "border-top": "1px solid #DBDFE3",
      "margin-top": "10px"
    }
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-mob text-right"
  }, [_c('span', {
    staticClass: "data-field"
  }, [_vm._v(_vm._s(_vm._f("firstLetter")(this.order.destinyAddress)) + " "), _c('br'), _vm._v(_vm._s(_vm._f("firstLetter")(this.order.destinyNameUbigeo)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('span', [_c('a', {
    staticClass: "a-tra",
    attrs: {
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function($event) {
        _vm.showModalCopiar = true
      }
    }
  }, [_c('i', {
    ref: "atrack",
    staticClass: "fa fa-link a-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Compartir Pedido")])])])])])])])])])]) : _vm._e()], 1) : (_vm.existe == 2 && !_vm.isOrder) ? _c('div', {
    staticClass: "msg-order"
  }, [(_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-bus",
    attrs: {
      "src": "/static/img/buscar.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title-bus"
  }, [_vm._v("\n            Hola,\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle-bus"
  }, [_vm._v("\n            Bienvenido a Dinet\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "p-bus"
  }, [_vm._v("\n            Para ver el estado de su pedido necesitamos que se identifique:\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "p-bus"
  }, [_vm._v("\n              Ingrese tus datos\n          ")]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.search()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fName),
      expression: "fName"
    }],
    staticClass: "form-control form-control-ora",
    class: {
      'is-invalid': _vm.submitted && !_vm.fName
    },
    attrs: {
      "placeholder": "Apellidos y/o Nombres"
    },
    domProps: {
      "value": (_vm.fName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitted && _vm.fName === ''),
      expression: "submitted && fName===''"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v("Los apellidos y/o nombres es requerido")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('button', {
    class: ['btn btn-ora', {
      'disabled': (_vm.submitted && _vm.fName === '')
    }],
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Continuar "), _c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])]), _vm._v(" "), (!_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-bus",
    attrs: {
      "src": "/static/img/buscar.png"
    }
  })]) : _vm._e()]) : (_vm.existe == 0) ? _c('div', {
    class: _vm.isOrder ? 'msg-nf-order' : 'msg-nf'
  }, [(_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-nf",
    attrs: {
      "src": "/static/img/noencontrado.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title-nf"
  }, [_vm._v("\n            No hemos podido encontrar tu pedido\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "p-nf"
  }, [_vm._v("\n            Comunicate con nosotros para brindarte información de tu pedido\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-ora",
    staticStyle: {
      "width": "200px"
    },
    on: {
      "click": function($event) {
        return _vm.contact()
      }
    }
  }, [_vm._v("Contáctate con nosotros")])]), _vm._v(" "), (!_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-nf",
    attrs: {
      "src": "/static/img/noencontrado.png"
    }
  })]) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "icon-tracking"
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label-bold-tra"
  }, [_vm._v("Tracking")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "icon-tracking"
  }, [_c('img', {
    staticClass: "icon-tracking-img",
    attrs: {
      "src": "/static/img/svg/document.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label-bold-tra"
  }, [_vm._v("Información del Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/document.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Tracking del Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/document.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Número del Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/user.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Cliente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/phone.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Número de Celular")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    staticStyle: {
      "width": "16px"
    },
    attrs: {
      "src": "/static/img/svg/location.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Dirección de origen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/destiny.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Dirección de entrega")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-icono"
  }, [_c('img', {
    staticClass: "help-img",
    attrs: {
      "src": "/static/img/help.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "label-bold-tra"
  }, [_vm._v("Estado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-icono"
  }, [_c('img', {
    staticClass: "help-img",
    attrs: {
      "src": "/static/img/help.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-md-6 col-lg-6 data-mob"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/document.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Tracking Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-md-6 col-lg-6 data-mob"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/document.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Número Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4 col-md-4 col-lg-4 data-mob"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/user.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Cliente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-md-6 col-lg-6 data-mob"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/phone.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Número Celular")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-md-6 col-lg-6 data-mob"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/location.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Dirección origen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 data-mob"
  }, [_c('span', {
    staticClass: "data-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/destiny.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "data-title"
  }, [_vm._v("Dirección entrega")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75664966!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tracking/TrackingNumber.vue
// module id = 531
// module chunks = 1